module.exports = __webpack_public_path__ + "static/media/grid.ddf621db.svg";